// Container3.js

import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { FaRegCopy } from "react-icons/fa";
import { CircularProgress } from "@mui/material";

const AvailableCouponsMobileView = ({
  activeLink,
  handleChange,
  loyaltyInfo,
  couponPoints,
  isCouponcodeDisabled,
  backgroundColors,
  onButtonClick,
  onClickApplyPromoCode,
  isWcoupon,
  handleCopyClick,
  copied,
  woocommerceCoupon,
  woocommerceCouponError,
  isLoder,
  handleCopyClick1,
  setPromoCode,
  loading,
}) => {
  const combinedItems = [...loyaltyInfo.coupons.tokens, ...loyaltyInfo.coupons.rewards];

  return (
    <div className="container3">
      <p style={{ fontWeight: 500, marginTop: "-10px", fontSize: "15px" }}>Enter Your Loyalty Coupon Code Here</p>
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Tabs
          value={activeLink === "REWARDS" ? 0 : 1}
          onChange={handleChange}
          centered
          sx={{
            "& .MuiTabs-indicator": { backgroundColor: "var(--primary-color)", width: "30px" },
          }} // Change the color of the indicator line here
        >
          <Tab label="Coupons" sx={{ textTransform: "capitalize", "&.Mui-selected": { color: "var(--primary-color)" } }} />
          <Tab label="Unused Coupons" sx={{ textTransform: "capitalize", "&.Mui-selected": { color: "var(--primary-color)" } }} />
        </Tabs>
      </Box>

      <div>
        {activeLink === "REWARDS" ? (
          loyaltyInfo?.coupons?.tokens?.length ? (
            <div className="tokes-rewards-coupons-container">
              {combinedItems.map((item, index) => (
                <div key={index} className="couponradiobutton">
                  <div className="token-card">{item?.token_code}</div>
                  <div className="token-info-container">
                    <p>{item?.name}</p>
                    <p>Valid: {item.valid_till.split("-").reverse().join("-")}</p>
                    <p>Use_limit: {item?.use_limit}</p>
                  </div>
                  <button className={couponPoints || isCouponcodeDisabled ? "apply-button1" : "apply-button"} onClick={() => onButtonClick(item, index)} disabled={couponPoints || isCouponcodeDisabled}>
                    Apply
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <div>
              <p style={{ textAlign: "center" }}>No coupons found</p>
            </div>
          )
        ) : activeLink === "TOKENS" ? (
          loyaltyInfo?.shopify_code?.length ? (
            <div className="tokes-rewards-coupons-container">
              {loyaltyInfo.shopify_code.map((item, index) => (
                <div key={index} className="couponradiobutton1">
                  <div
                    className="couponcodecontainer"
                    style={{
                      background: `linear-gradient(to top left, ${backgroundColors[index % backgroundColors.length].start} 50%, ${backgroundColors[index % backgroundColors.length].end} 50%)`,
                      marginBottom: "10px",
                    }}
                  >
                    <div className="coupondiscountcontainer"></div>
                    <div className="coupondiscounttext">
                      <p>{item?.name}</p>
                    </div>
                  </div>
                  <div className="couponname">
                    <p className="validcoupon">{item.shopify_code}</p>
                  </div>
                  <button className={isCouponcodeDisabled || isWcoupon ? "apply-button1" : "apply-button"} disabled={isCouponcodeDisabled || couponPoints || isWcoupon} onClick={() => handleCopyClick1(item?.shopify_code)}>
                    Copy
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ textAlign: "center" }}>No coupons found</p>
          )
        ) : (
          <p style={{ textAlign: "center" }}>No coupons found</p>
        )}
      </div>
      {isLoder && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px", marginLeft: "0px" }}>
          <CircularProgress sx={{ color: "var(--primary-color)" }} />
        </div>
      )}

      {woocommerceCoupon && !isLoder && (
        <div className="custom-textfield2">
          <p>{woocommerceCoupon}</p>
          {!copied ? <FaRegCopy onClick={handleCopyClick} style={{ marginTop: "0px", marginLeft: "30px", cursor: "pointer" }} /> : <p style={{ marginTop: "15px", marginLeft: "30px", color: "green" }}>Copied!</p>}
        </div>
      )}
      {!isLoder && (
        <div className="points-redem-container1">
          <input disabled={woocommerceCoupon} onChange={(e) => setPromoCode(e.target.value)} className="custom-textfield" />
          <button disabled={woocommerceCoupon} onClick={onClickApplyPromoCode} className={woocommerceCoupon ? "custom-button2 mobile-field" : "custom-button1 mobile-field"}>
            {loading ? <CircularProgress size={25} sx={{ color: "var(--secondary-color)" }} /> : "Apply Promo Code"}
          </button>
        </div>
      )}
      {woocommerceCouponError && <p className="error-msg">{woocommerceCouponError}</p>}
      {isWcoupon ? (
        <h3 className="mobilescreen-text">
          <span style={{ color: "var(--primary-color)" }}>Note: </span>Once you've redeemed your points or coupons, get the code and input it in the coupon field before completing your purchase to receive the discount.
        </h3>
      ) : (
        ""
      )}
    </div>
  );
};

export default AvailableCouponsMobileView;
